import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"
import { Doughnut, Bar } from "react-chartjs-2"
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  ArcElement,
  Title,
  Tooltip,
  Legend,
  BarElement,
} from "chart.js"
import "../styles/AdminCharts.css"
import { fetchReviews } from "../../store/reviews"

ChartJS.register(
  CategoryScale,
  LinearScale,
  ArcElement,
  BarElement,
  Title,
  Tooltip,
  Legend
)

const initialChartData = {
  labels: [],
  datasets: [
    {
      label: "",
      data: [],
      backgroundColor: [],
      borderColor: [],
      borderWidth: 1,
    },
  ],
}

const AdminReviewsChart = () => {
  const dispatch = useDispatch()
  const reviews = useSelector((state) => state.reviews.reviews)
  const [ratingsDistributionChartData, setRatingsDistributionChartData] =
    useState(initialChartData)
  const [ratingsOverTimeChartData, setRatingsOverTimeChartData] =
    useState(initialChartData)
  const [topReviewedProductsChartData, setTopReviewedProductsChartData] =
    useState(initialChartData)

  useEffect(() => {
    dispatch(fetchReviews())
  }, [dispatch])

  useEffect(() => {
    if (reviews.length) {
      const ratingsDistribution = new Array(5).fill(0)
      const ratingsOverTime = {}
      const topReviewedProducts = {}

      reviews.forEach((review) => {
        ratingsDistribution[review.rating - 1]++
        const reviewDate = new Date(review.createdAt).toLocaleDateString()
        ratingsOverTime[reviewDate] =
          (ratingsOverTime[reviewDate] || 0) + review.rating

        const productName = review.product.name
        topReviewedProducts[productName] =
          (topReviewedProducts[productName] || 0) + 1
      })

      setRatingsDistributionChartData({
        labels: ["1 Star", "2 Stars", "3 Stars", "4 Stars", "5 Stars"],
        datasets: [
          {
            label: "Ratings Distribution",
            data: ratingsDistribution,
            backgroundColor: [
              "rgba(76, 175, 80, 0.5)",
              "rgba(178, 178, 178, 0.5)",
              "rgba(255, 99, 132, 0.5)",
              "rgba(54, 162, 235, 0.5)",
              "rgba(255, 159, 64, 0.5)",
            ],
            borderColor: [
              "rgba(76, 175, 80, 1)",
              "rgba(178, 178, 178, 1)",
              "rgba(255, 99, 132, 1)",
              "rgba(54, 162, 235, 1)",
              "rgba(255, 159, 64, 1)",
            ],
          },
        ],
      })

      setRatingsOverTimeChartData({
        labels: Object.keys(ratingsOverTime),
        datasets: [
          {
            label: "Average Rating Over Time",
            data: Object.values(ratingsOverTime).map(
              (total, idx, arr) => total / (idx + 1)
            ),
            backgroundColor: "rgba(54, 162, 235, 0.5)",
            borderColor: "rgba(54, 162, 235, 1)",
          },
        ],
      })

      setTopReviewedProductsChartData({
        labels: Object.keys(topReviewedProducts),
        datasets: [
          {
            label: "Top Reviewed Products",
            data: Object.values(topReviewedProducts),
            backgroundColor: "rgba(153, 102, 255, 0.5)",
            borderColor: "rgba(153, 102, 255, 1)",
          },
        ],
      })
    }
  }, [reviews])

  return (
    <div className="myChart-container">
      <div className="chart-container">
        <h3>Ratings Distribution</h3>
        <Doughnut
          data={ratingsDistributionChartData}
          className="myChart-canvas"
        />
      </div>
      <div className="chart-container">
        <h3>Ratings Over Time</h3>
        <Bar
          data={ratingsOverTimeChartData}
          className="barChart-canvas"
          options={{ indexAxis: "x" }}
        />
      </div>
      <div className="chart-container">
        <h3>Top Reviewed Products</h3>
        <Bar
          data={topReviewedProductsChartData}
          className="barChart-canvas"
          options={{ indexAxis: "y" }}
        />
      </div>
    </div>
  )
}

export default AdminReviewsChart
